<template>
    <small-dialog
        @ok="create"
        v-model="dialog"
        title="Buat Indeks Kesulitan baru"
        okButton="buat"
        loading="difficultyindex"
    >
        <template #activator="{ on }">
            <div class="text-right mb-4">
                <v-btn
                    v-on="on"
                    color="primary"
                    rounded
                >
                    buat baru
                </v-btn>
            </div>
        </template>

        <v-text-field
            v-model="form.title"
            label="Nama indeks kesulitan"
            autofocus
        ></v-text-field>

        <v-textarea
            v-model="form.description"
            label="Deskripsi indeks kesulitan"
        ></v-textarea>
    </small-dialog>
</template>

<script>
import SmallDialog from '@/components/dialog/SmallDialog'

const form = () => ({
    title: null,
    description: null,
})

export default {
    components: {
        SmallDialog,
    },

    data: () => ({
        dialog: false,
        form: form(),
    }),

    methods: {
        async create() {
            await this.$apiv2.post('difficulty-index', this.form, {
                loader: 'difficultyindex',
            })

            this.dialog = false
            this.$emit('create')
        },
    },
}
</script>
